interface StyledCardProps {
  title: string;
  body?: React.ReactNode;
  cta: React.ReactNode;
}

export const StyledCard = (props: StyledCardProps) => {
  return (
    <div className="position-relative bg-primary rounded-lg mb-5">
      {/* SVG decorations as siblings, behind the card */}
      <span
        aria-hidden="true"
        css={`
          position: absolute;
          background-repeat: no-repeat;
          background-size: contain;
          z-index: 1;
          opacity: 1;

          left: 1.75rem;
          bottom: 2rem;
          width: 3rem;
          height: 3rem;
          background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ3Ij4KCTxwYXRoIGZpbGw9IiNENDhFRjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNC41Nzc2NGUtMDUpIiBkPSJNNDYgMEwwIDBDMCAyNS40MDQ4OTQgMjAuNTkyOTkzIDQ2IDQ2IDQ2TDQ2IDBaIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==");
        `}
      />
      <span
        aria-hidden="true"
        css={`
          position: absolute;
          background-repeat: no-repeat;
          background-size: contain;
          z-index: 1;
          opacity: 1;

          position: absolute;
          top: 0;
          right: 0;
          width: 6rem;
          height: 6rem;
          background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9Ijk1IiBoZWlnaHQ9Ijk1Ij4KCTxwYXRoIGZpbGw9IiM3RjM1QTkiIGQ9Ik05NSA0NC44NzI2MjdDNzAuMjU2MTE5IDQ0Ljg3MjYyNyA1MC4xMjYyMTMgMjQuNzQyMjU2IDUwLjEyNjIxMyAwTDAgMEMwIDEyLjgxMzIzMiAyLjUxNDMxOTkgMjUuMjU3ODUxIDcuNDc0OTQ1MSAzNi45ODUwMzFDMTIuMjYwMDQ4IDQ4LjI5OTcyNSAxOS4xMDc1MDYgNTguNDU4MTY0IDI3LjgyMjA1MiA2Ny4xNzUxMUMzNi41Mzg3OTkgNzUuODkyMDUyIDQ2LjY5NDgwNSA4Mi43Mzc0NzMgNTguMDExNDMzIDg3LjUyNDg4N0M2OS43NDA1MzIgOTIuNDg1NjI2IDgyLjE4NDg3NSA5NSA5NSA5NUw5NSA0NC44NzI2MjdaIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==");
        `}
      />

      {/* Actual content */}
      <div
        className="text-white text-center p-5 position-relative"
        css={`
          z-index: 2;
        `}
      >
        <h2
          className="h3"
          css={`
            margin-bottom: 2rem;
          `}
        >
          {props.title}
        </h2>
        {typeof props.body === "string" ? (
          <p
            className="lead"
            css={`
              margin-bottom: 2rem;
            `}
          >
            {props.body}
          </p>
        ) : (
          props.body
        )}
        {props.cta}
      </div>
    </div>
  );
};
